module.exports = __webpack_public_path__ + "static/media/green_tow.cbad1a38.png";